import BaseService from "./BaseService";

export default {
    login(data) {
        return BaseService.post('/login', data);
    },
    register(data) {
        return BaseService.post('/register', data);
    }
}